










































import studentSelector from "./studentSelector.vue";
import {
  addLessonStudent,
  getLessonDetail,
  getLessonStudentList,
} from "@/api/lesson";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "addExperienceDialog",
  components: {
    studentSelector,
  },
})
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() lessonId!: any;
  followForm: any = {
    class: {},
    course: {},
    student_ids: [],
  };
  rules = {
    student_ids: [
      {
        required: true,
        message: "请选择体验课学员",
        trigger: "change",
      },
    ],
  };
  disableItems: any[] = [];
  created() {
    getLessonDetail({
      lesson_id: this.lessonId,
    }).then((res: any) => {
      res.data.student_ids = [];
      this.followForm = res.data;
    });
    getLessonStudentList({
      lesson_id: this.lessonId,
    }).then((res: any) => {
      this.disableItems = res.data.list;
    });
  }
  saveFollow() {
    (this.$refs["followForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          this.$confirm(
            `确定将学员跟随班级 [${this.followForm.class.name}]，时间 ${
              this.followForm.date
            } (周${
              ["日", "一", "二", "三", "四", "五", "六"][
                this.followForm.week_day
              ]
            }) ${this.followForm.start_time.slice(
              0,
              5
            )} ~ ${this.followForm.end_time.slice(0, 5)}，课次体验？`,
            `跟班体验 - 已选择 ${this.followForm.student_ids.length} 人`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            }
          )
            .then(() => {
              const params: any = {
                lesson_id: this.lessonId,
                student_type: 5,
                in_roll_call: false,
                student_list: [],
              };
              const arr: any[] = [];
              this.followForm.student_ids.map((id: number) => {
                arr.push({
                  student_id: id,
                  course_id: this.followForm.course.course_id,
                });
              });
              params.student_list = arr;
              addLessonStudent(params).then(() => {
                this.$message({
                  type: "success",
                  message: "添加成功!",
                });
                this.$emit("change");
                this.closeDialog();
              });
            })
            .catch(() => {});
        }
      }
    );
  }
  closeDialog() {
    this.$emit("update:visible", false);
  }
}
